// import { faInfoCircle } from "@fortawesome/free-solid-svg-icons"
import { faInfoCircle } from "@fortawesome/pro-solid-svg-icons"
import Icon from "./Icon"

export const Mandantory = ({ label, show = false, tooltip }) => {
    return (
        <span>
            {label}
            {/* {show && <span style={{ color: 'red', fontSize: '14px' }}>&nbsp;*</span>}
            &nbsp;
            <Icon
                Icon={faInfoCircle}
                size={12}  
            /> */}
        </span>
    )
}
